// extracted by mini-css-extract-plugin
module.exports = {"table":"table-module--table--1pycL","row":"table-module--row--1-qMn","cell":"table-module--cell--POTb-"};